import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <p>
        <i>© 2025 SolarPortfolio — All Rights Reserved.</i>
      </p>
    </footer>
  );
};

export default Footer;
